// Add your custom JS here.

jQuery(document).ready(function($) {
	
	// CSS classes to let us know whether to adapt to no js :). 
	$('body').removeClass('no-js').addClass('js-enabled'); 
	
	/*****************************************
	 * Make sure skip to content link is at top
	 ****************************************/
	
	function moveElementToBodyStart(elementId) {
		let element = document.getElementById(elementId);
		
		if (element && document.body.firstChild) {
			document.body.insertBefore(element, document.body.firstChild);
		} else if (element) {
			document.body.appendChild(element); // Fallback if body is empty
		}
	}
	
	// Example usage
	moveElementToBodyStart('skip-to-content');
	
	/******************************************
	 * Esc closes navbar
	 *****************************************/
	document.addEventListener("keydown", function (event) {
		if (event.key === "Escape") {
			let navbarToggler = document.querySelector(".navbar-toggler");
			let navbarCollapse = document.querySelector(".navbar-collapse");
			
			if (navbarToggler && navbarCollapse.classList.contains("show")) {
				navbarToggler.click(); // Simulates a click to close the menu
			}
		}
	});
	
	
	/*****************************************
	 * HEADER SEARCH
	 ****************************************/
	$('.header-search .search-field').attr('tabindex','-1');
	$('.show-search').on('click', function(e) {
		$('.header-search').toggleClass('active');
		$(this).toggleClass('active');
		$('.searchlogins .search-field').attr('tabindex','0').focus();
		
		$('.show-logins').removeClass('active').attr('aria-expanded',false);
		$('.searchlogins').removeClass('active');
		$('#login-nav').removeClass('active');
		$('#login-menu > li > a').attr('tabindex','-1');
	});
	
	/*****************************************
	 * LOGIN BUTTON
	 ****************************************/
	$('#login-menu > li > a').attr('tabindex','-1');
	$('.show-logins').on('click', function(e) {
		$(this).toggleClass('active');
		$('.searchlogins').toggleClass('active');
		$('#login-nav').toggleClass('active');
		
		
		if($(this).hasClass('active')) {
			$(this).attr('aria-expanded',true);
			$('#login-menu > li > a').attr('tabindex','0');
		} else {
			$(this).attr('aria-expanded',false);
			$('#login-menu > li > a').attr('tabindex','-1');
		}
		
		$('.header-search').removeClass('active');
		$('.searchlogins .search-field').attr('tabindex','-1');
		$('.show-search').removeClass('active');
	});
	
	$('body').on('click focusin', function (e) {
		
		if($(e.target).closest('.show-logins, #login-nav > *, #login-nav').length == 0) {
			$('.show-logins').removeClass('active').attr('aria-expanded',false);
			$('#login-nav').removeClass('active');
			$('#login-menu > li > a').attr('tabindex','-1');
		}
		
	}); 
	
	$('.show-mob-logins').on('click', function(e) {
		$(this).toggleClass('active');
		$(this).toggleClass('show');
		if($(this).hasClass('show')) {
			$(this).attr('aria-expanded','true');
		} else {
			$(this).attr('aria-expanded','false');
		}
		
		$('#mobile-nav').slideToggle().toggleClass('active');
		
		$('.show-logins').removeClass('active').attr('aria-expanded',false);
		$('.searchlogins .search-field').attr('tabindex','-1');
		$('#login-menu > li > a').attr('tabindex','-1');
		$('.searchlogins').removeClass('active');
		$('#login-nav').removeClass('active');
		$('.header-search').removeClass('active');
		$('.show-search').removeClass('active');
	});
	
	function dropdownslideup(element) {
		var parent = element.parent();
		if(!$('.dropdown-menu', parent).hasClass('active')) {
			$('.dropdown-menu.active').slideUp().removeClass('active');
		}
		$('.dropdown-menu', parent).slideToggle().addClass('active');
	}
	
	$('#main-nav .navbar-toggler').on('click', function() {
		$('body').toggleClass('menuopen');
	});
	
	$('#mobile-login-menu li.dropdown a, #main-menu li.dropdown a, #login-menu li.dropdown a').on('click', function(e) {
		var ww = window.innerWidth;
		
		console.log('Fired First Query');
		var grandparent = $(this).parent().parent();
		
		
		if(ww < 992) {
			console.log('ww is smaller than 992px');
			/*var parent = $(this).parent();
			if(!$('.dropdown-menu', parent).hasClass('active')) {
				$('.dropdown-menu.active').slideUp().removeClass('active');
			}
			$('.dropdown-menu', parent).slideToggle().addClass('active');*/
			dropdownslideup($(this));
		} else if(grandparent.attr('id') == 'login-menu') {
			/*var parent = $(this).parent();
			if(!$('.dropdown-menu', parent).hasClass('active')) {
				$('.dropdown-menu.active').slideUp().removeClass('active');
			}
			$('.dropdown-menu', parent).slideToggle().addClass('active');*/
			dropdownslideup($(this));
		}
			
	});
	
	$('#main-menu li.dropdown').on('click', function(e) {
		var ww = window.innerWidth;
		
		console.log('Fired Second Query'); 
		
		if(ww >= 992) {
			console.log('ww is larger or equal to 992px');
			var parent = $(this).parent();
			$('.dropdown-menu.active').removeAttr("style");
			
			if(parent.attr('id') == 'login-menu') {
				
				$('.dropdown-menu', parent).slideToggle().addClass('active');
				if($(this).hasClass('show')) {
					$('.dropdown-menu', $(this)).addClass('animated fadeOutUp');
				} else {
					$('.dropdown-menu', $(this)).addClass('animated fadeInDown');
				}
			} else {
				
				if($(this).hasClass('show')) {
					$('.dropdown-menu', $(this)).addClass('animated smfadeOutUp');
				} else {
					$('.dropdown-menu', $(this)).addClass('animated smfadeInDown');
				}
			}
		}
	});
	
	/*****************************************
		HEADER SCROLL TRANSITIONS
	*****************************************/
	
	// If the page has been reloaded it might have already scrolled this checks if this is the case
	var currentScroll = $(document).scrollTop();
	
	// If page has loaded further down...
	if(currentScroll > 0) {
		hasScrolled(); // trigger the has scrolled function. 
	}
	
	// Set some default Variables
	var didScroll;				// True / False has the page been scrolled
	var mobDidScroll;			// True / False has the mobile menu been scrolled
	var lastScrollTop = 0;		// Last Scroll Top Position. 
	var mobLastScrollTop = 0;		// Last Scroll Top Position. 
	var delta = 5;				// How far the user has scrolled before this is triggered. 
	var navbarHeight = $('.header').outerHeight(); // Current height of the header (this may change if the window is resized).

	// When the page is scrolled
	$(document).scroll(function(event){
		didScroll = true;
	});
	
	// When mobile menu is scrolled
	$('#navbarNavDropdown').scroll(function(event) {
		console.log('mobile nav has scrolled');
		mobDidScroll = true; 
	});
	
	$('.show-mob-logins').on('focus', function(event) {
		$('#navbarNavDropdown').scrollTop(0);
	});

	// fire after 250ms 
	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);
	setInterval(function() {
		if (mobDidScroll) {
			mobHasScrolled();
			mobDidScroll = false;
		}
	}, 250);

	// Function to run when scrolling has occured. 
	function hasScrolled() {
		// Fetch the current scroll position. 
		var st = $(document).scrollTop();
		var windowheight = $(window).height();
		var docheight = $(document).height();
		
		// If the scroll point is further down than 250 add the scroll class (this adds a background to the header)
		if(Math.abs(st) > 250) {
			$('.header').addClass('nav-scroll');
		} else {
			$('.header').removeClass('nav-scroll'); // remove the scroll class if it's near the top. 
		}
		
		// Make sure they scroll more than delta otherwise just ignore.
		if(Math.abs(lastScrollTop - st) <= delta) {
			return;
		} 
		
		
		// If they scrolled down and are past the navbar, add class .nav-up.
		if (st > lastScrollTop && st > navbarHeight){
			// Scroll Down (hides the header)
			$('.header').removeClass('nav-down').addClass('nav-up');
			if(st > windowheight && st > (docheight - (windowheight + 20))) {
				$('.backtotop').fadeIn();
			} else {
				$('.backtotop').fadeOut();
			}
		} else {
			// Scroll Up (shows the header to save the user scrolling up)
			if(st + windowheight < docheight) {
				$('.header').removeClass('nav-up').addClass('nav-down');
			}
			if(st > windowheight) {
				
				$('.backtotop').fadeIn(); 
			} else {
				$('.backtotop').fadeOut();
			}
		}
		
		// reset the last scroll point 
		lastScrollTop = st;
	}
	
	function mobHasScrolled() {
		// Fetch the current scroll position. 
		var st = $('#navbarNavDropdown').scrollTop(); console.log(st);
		var windowheight = $(window).height();
		var docheight = $(document).height();
		
		// If the scroll point is further down than 150 add the scroll class (this adds a background to the header)
		if(Math.abs(st) > 50) {
			$('.header').addClass('nav-scroll');
		} else {
			$('.header').removeClass('nav-scroll'); // remove the scroll class if it's near the top. 
		}
		
		console.log(Math.abs(st) + ' > 50');
		
		// Make sure they scroll more than delta otherwise just ignore.
		if(Math.abs(mobLastScrollTop - st) <= delta) {
			return;
		} 
		
		
		// If they scrolled down and are past the navbar, add class .nav-up.
		if (st > mobLastScrollTop && st > navbarHeight){
			// Scroll Down (hides the header)
			$('.header').removeClass('nav-down').addClass('nav-up');
			if(st > windowheight && st > (docheight - (windowheight + 20))) {
				$('.backtotop').fadeIn();
			} else {
				$('.backtotop').fadeOut();
			}
		} else {
			// Scroll Up (shows the header to save the user scrolling up)
			if(st + windowheight < docheight) {
				$('.header').removeClass('nav-up').addClass('nav-down');
			}
			if(st > windowheight) {
				
				$('.backtotop').fadeIn(); 
			} else {
				$('.backtotop').fadeOut();
			}
		}
		
		// reset the last scroll point 
		mobLastScrollTop = st;
	}
	
	/*********************************************
	 * Load More News
	 ********************************************/
	$('a.loadnews').on('click', function(e) {
		e.preventDefault();
		
		var page = $(this).attr('data-page');
		$(this).addClass('loading').append(' <span class="icon-refresh rotating ms-1" aria-live="polite" aria-label="loading"></span>');
		$.get(
			wpvars.resturl+'wp/v2/posts?per_page=9&page='+page, 
			function(data, status){
				
				const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
				
				function get_sup(date) {
					if($.inArray( date, [ 1, 21, 31 ] ) >= 0) {
						return 'st';
					} else if($.inArray( date, [ 2, 22 ] ) >= 0) {
						return 'nd';
					} else if($.inArray( date, [ 3, 23 ] ) >= 0) {
						return 'rd';
					} else {
						return 'th';
					}
				}
				
				
				if(status == "success") {
					page++;
					$('a.loadnews').attr('data-page',page);
					var firstid = 0;
					
					$.each(data, function( index, value ) {
						
						if(index == 0) {
							firstid = value.id;
						}
						
						const d = new Date(value.date);
						let day = d.getDate();
						
						var html = '<a href="'+value.link+'" rel="bookmark" class="col-12 col-sm-6 col-lg-4 has-dgc-white-background-color has-background p-4 m-0 d-flex flex-column justify-content-start post-'+value.id+' post type-post status-publish format-standard hentry category-news hide-article" id="post-'+value.id+'" tabindex="0">'+
							'<div class="entry-meta small">'+
								'<span class="posted-on fw-bold has-dgc-navy-75-color has-text-color">'+
									'<span class="icon-calendar" aria-hidden="true"></span> '+
									'<span class="visually-hidden">Posted on</span>'+
									'<time class="entry-date published" datetime="'+value.date+'">'+day+'<sup>'+get_sup(day)+'</sup> '+months[d.getMonth()]+', '+d.getFullYear()+'</time>'+
								'</span>'+
							'</div>'+
							'<h2 class="entry-title h6"><span>'+value.title.rendered+'</span></h2>'+
							'<div class="entry-content">'+value.excerpt.rendered+'</div>'+
							'<div class="entry-footer align-self-end flex-grow-1 d-flex flex-column justify-content-end">'+
								'<span class="btn btn-link is-style-link wp-element-button">Read more</span>'+
							'</div>'+
						'</a>';
						
						$('.article-wrapper').append(html);
						$('#post-'+value.id).addClass('animated smfadeInDown');
						
					});
					
					$('a.loadnews').removeClass('loading');
					$('a.loadnews .icon-refresh').remove();
					$('a#post-'+firstid).focus(); 
				} else {
					$('a.loadnews').removeClass('loading');
					$('a.loadnews .icon-refresh').remove();
				}
			});
		
		
		
		//https://192.168.41.44/rebecca/collegeweb/wp-json/wp/v2/posts?page=2
		
	});
	
});
